import { CheckCheckIcon, ClockIcon } from "lucide-react";
import { cn } from "../../lib/utils";

/** Illustrative WhatsApp-style conversation inside a phone frame. Decorative sample, not a real chat. */
export function ChatPhone({ business, items, className, liveKey }) {
  return (
    <figure
      className={cn(
        "relative mx-auto w-full max-w-[320px] rounded-[2.2rem] border border-black/10 bg-charcoal p-2.5 shadow-card-float",
        className
      )}
      aria-label={`Sample WhatsApp conversation for ${business}`}
    >
      <div className="overflow-hidden rounded-[1.75rem] bg-[#efeae2]">
        <div className="flex items-center gap-3 bg-brand-deep px-4 py-3 text-white">
          <div
            className="flex size-8 items-center justify-center rounded-full bg-white/20 text-sm font-semibold"
            aria-hidden="true"
          >
            {business.charAt(0)}
          </div>

          <div className="min-w-0">
            <p className="truncate text-sm font-semibold">{business}</p>
            <p className="text-xs text-white/80">
              Official business account
            </p>
          </div>
        </div>

        <div
          key={liveKey}
          aria-live="polite"
          className="flex min-h-[340px] flex-col gap-2.5 p-3 animate-in fade-in-0 duration-300"
        >
          {items.map((item, i) => {
            if (item.from === "label") {
              return (
                <p
                  key={i}
                  className="mx-auto flex items-center gap-1.5 rounded-md bg-white/80 px-2.5 py-1 text-[11px] font-medium text-ink-strong"
                >
                  <ClockIcon className="size-3" aria-hidden="true" />
                  {item.text}
                </p>
              );
            }

            const mine = item.from === "business";

            return (
              <div
                key={i}
                className={cn(
                  "flex flex-col gap-1.5",
                  mine ? "items-end" : "items-start"
                )}
              >
                <div
                  className={cn(
                    "max-w-[85%] rounded-lg px-3 py-2 text-[13px] leading-snug shadow-sm",
                    mine
                      ? "rounded-tr-none bg-[#d9fdd3] text-black"
                      : "rounded-tl-none bg-white text-black"
                  )}
                >
                  <span className="sr-only">
                    {mine ? `${business}: ` : "Customer: "}
                  </span>

                  {item.text}

                  <span className="mt-1 flex items-center justify-end gap-1 text-[10px] text-black/50">
                    {item.time ?? "now"}

                    {mine && (
                      <CheckCheckIcon
                        className="size-3 text-[#53bdeb]"
                        aria-hidden="true"
                      />
                    )}
                  </span>
                </div>

                {mine && item.buttons && item.buttons.length > 0 && (
                  <div
                    className="flex w-[85%] flex-col gap-1"
                    aria-label="Quick reply buttons"
                  >
                    {item.buttons.map((b) => (
                      <span
                        key={b}
                        className="rounded-lg bg-white px-3 py-1.5 text-center text-[12px] font-medium text-[#027eb5] shadow-sm"
                      >
                        {b}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </figure>
  );
}